(function () {
    'use strict';

    angular.module("imApp").factory("webpageSettingEditService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 19,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 20,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
